import { clientbookApi } from '../core/clientbook-api';

// Google

export const getGoogleLocations = async () => {
  return clientbookApi.get({ url: '/google/locations' });
};

export const saveGoogleLocationMappings = async mappings => {
  const relevant = mappings.filter(m => m.storeId !== '0');
  for (const { storeId, accountId, extRefId, title } of relevant) {
    if (accountId && extRefId && extRefId !== 'unmapped') {
      await clientbookApi.patch({
        url: `/stores/${storeId}/google/location`,
        data: { extRefId, accountId: Number(accountId), title },
      });
    } else {
      try {
        await clientbookApi.delete({ url: `/stores/${storeId}/google/location` });
      } catch {
        // 404 means no existing mapping — nothing to delete
      }
    }
  }
};

export const uninstallGoogleIntegration = async () => {
  return clientbookApi.delete({ url: '/google/integration' });
};

// Facebook

export const getFacebookPages = async () => {
  return clientbookApi.get({ url: '/meta/facebook/pages' });
};

export const saveFacebookPageMappings = async mappings => {
  const updates = mappings.filter(m => m.accountId && m.extRefId && m.extRefId !== 'unmapped');
  for (const { storeId, extRefId, accountId } of updates) {
    await clientbookApi.patch({
      url: `/stores/${storeId}/meta/facebook/page`,
      data: { extRefId, accountId },
    });
  }
};

export const uninstallFacebookIntegration = async () => {
  return clientbookApi.delete({ url: '/meta/facebook/accounts' });
};

// Instagram

export const getInstagramAccounts = async () => {
  return clientbookApi.get({ url: '/meta/instagram/accounts' });
};

export const saveInstagramAccountMappings = async mappings => {
  const updates = mappings.filter(m => m.extRefId && m.extRefId !== 'unmapped');
  for (const { storeId, extRefId } of updates) {
    await clientbookApi.patch({
      url: `/stores/${storeId}/meta/instagram/account`,
      data: { extRefId },
    });
  }
};

export const uninstallInstagramIntegration = async () => {
  return clientbookApi.delete({ url: '/meta/instagram/accounts' });
};

// Merchant

export const getBlacklistWords = async () => {
  return clientbookApi.get({ url: '/merchants/blacklistwords' });
};
